<template>
    <div class="container pt-50 pb-50">
        <div class="d-flex align-items-center gap-2 breadcrumb pb-25" v-if="breadcrumb1 !== ''">
            <span>{{ breadcrumb1 }}</span> <i class="fa-solid fa-chevron-right"></i> <span v-if="breadcrumb2 !== ''">{{
            breadcrumb2 }}</span> <i v-if="breadcrumb2 !== ''" class="fa-solid fa-chevron-right"></i>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-5 tablette">
                    <div class="accordion" id="accordionExample">
                        <div class="accordion-item"
                            v-if="tab !== 'organisme-formation' && tab !== 'soft-skills' && tab !== 'ressources-humaines-rse' && tab !== 'leadership-management'">
                            <h2 class="accordion-header">
                                <button class="accordion-button"
                                    :class="{ collapsed: (tab !== 'pcrh' && tab !== 'marque_employeur' && tab !== 'entretien_annuel_professionnel' && tab !== 'obligations_legales' && tab !== 'gepp') }"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                                    aria-expanded="false" aria-controls="collapseOne">
                                    <i class="fa-regular fa-user-check me-2"></i> Conseil RH
                                </button>
                            </h2>
                            <div id="collapseOne" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'pcrh' || tab === 'marque_employeur' || tab === 'entretien_annuel_professionnel' || tab === 'obligations_legales' || tab === 'gepp') }"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'pcrh') }">
                                            <a href="/conseil_rh/pcrh"><span>PCRH</span></a>
                                            <i v-if="tab === 'pcrh'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'marque_employeur') }">
                                            <a href="/conseil_rh/marque_employeur"><span>Marque employeur</span></a>
                                            <i v-if="tab === 'marque_employeur'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'entretien_annuel_professionnel') }">
                                            <a href="/conseil_rh/entretien_annuel_professionnel"><span>Entretien annuel
                                                    et
                                                    professionnel</span></a>
                                            <i v-if="tab === 'entretien_annuel_professionnel'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'obligations_legales') }">
                                            <a href="/conseil_rh/obligations_legales"><span>Obligations
                                                    légales</span></a>
                                            <i v-if="tab === 'obligations_legales'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'gepp') }">
                                            <a href="/conseil_rh/gepp"><span>GEPP</span></a>
                                            <i v-if="tab === 'gepp'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item"
                            v-if="tab !== 'organisme-formation' && tab !== 'soft-skills' && tab !== 'ressources-humaines-rse' && tab !== 'leadership-management'">
                            <h2 class="accordion-header">
                                <button class="accordion-button"
                                    :class="{ collapsed: (tab !== 'audit-social' && tab !== 'gap' && tab !== 'supervision' && tab !== 'mediation' && tab !== 'prevention-rps') }"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                    aria-expanded="false" aria-controls="collapseTwo">
                                    <i class="fa-regular fa-user-gear me-2"></i> Qualité de vie et conditions de travail
                                </button>
                            </h2>
                            <div id="collapseTwo" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'audit-social' || tab === 'gap' || tab === 'supervision' || tab === 'mediation' || tab === 'prevention-rps') }"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'audit-social') }">
                                            <a href="/qualite-vie-condition-travail/audit-social"><span>Audit
                                                    social</span></a>
                                            <i v-if="tab === 'audit-social'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'gap') }">
                                            <a href="/qualite-vie-condition-travail/gap"><span>GAP</span></a>
                                            <i v-if="tab === 'gap'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'supervision') }">
                                            <a
                                                href="/qualite-vie-condition-travail/supervision"><span>Supervision</span></a>
                                            <i v-if="tab === 'supervision'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'mediation') }">
                                            <a
                                                href="/qualite-vie-condition-travail/mediation"><span>Médiation</span></a>
                                            <i v-if="tab === 'mediation'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'prevention-rps') }">
                                            <a href="/qualite-vie-condition-travail/prevention-rps"><span>Prévention
                                                    RPS</span></a>
                                            <i v-if="tab === 'prevention-rps'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item"
                            v-if="tab !== 'organisme-formation' && tab !== 'soft-skills' && tab !== 'ressources-humaines-rse' && tab !== 'leadership-management'">
                            <h2 class="accordion-header">
                                <button class="accordion-button"
                                    :class="{ collapsed: (tab !== 'coaching_professionnel' && tab !== 'conduite_du_changement' && tab !== 'accompagnement_codir' && tab !== 'team_building' && tab !== 'co_developpement') }"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                    aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fa-regular fa-screen-users me-2"></i> Management
                                </button>
                            </h2>
                            <div id="collapseThree" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'coaching_professionnel' || tab === 'conduite_du_changement' || tab === 'accompagnement_codir' || tab === 'team_building' || tab === 'co_developpement') }"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'coaching_professionnel') }">
                                            <a href="/management/coaching_professionnel"><span>Coaching individuel et
                                                    collectif</span></a>
                                            <i v-if="tab === 'coaching_professionnel'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'conduite_du_changement') }">
                                            <a href="/management/conduite_du_changement"><span>Conduite du
                                                    changement</span></a>
                                            <i v-if="tab === 'conduite_du_changement'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'accompagnement_codir') }">
                                            <a href="/management/accompagnement_codir"><span>Accompagnement
                                                    CODIR</span></a>
                                            <i v-if="tab === 'accompagnement_codir'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'team_building') }">
                                            <a href="/management/team_building"><span>Teambuilding</span></a>
                                            <i v-if="tab === 'team_building'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'co_developpement') }">
                                            <a href="/management/co_developpement"><span>Co-développement</span></a>
                                            <i v-if="tab === 'co_developpement'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item"
                            v-if="tab !== 'organisme-formation' && tab !== 'soft-skills' && tab !== 'ressources-humaines-rse' && tab !== 'leadership-management'">
                            <h2 class="accordion-header">
                                <button class="accordion-button"
                                    :class="{ collapsed: (tab !== 'transition-pro' && tab !== 'outplacement' && tab !== 'bilan-retraite' && tab !== 'activ-projet') }"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                    aria-expanded="true" aria-controls="collapseThree">
                                    <i class="fa-regular fa-building-user me-2"></i> Transition professionnelle
                                </button>
                            </h2>
                            <div id="collapseFour" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'transition-pro' || tab === 'outplacement' || tab === 'bilan-retraite' || tab === 'activ-projet') }"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'bilan-competences') }">
                                            <a href="/bilan_competences"><span>Bilan de compétences</span></a>
                                            <i v-if="tab === 'bilan-competences'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'organisme-formation') }">
                                            <a href="/organisme-formation"><span>Formation</span></a>
                                            <i v-if="tab === 'organisme-formation'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'outplacement') }">
                                            <a
                                                href="/transition-professionnelle/outplacement"><span>Outplacement</span></a>
                                            <i v-if="tab === 'outplacement'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'bilan-retraite') }">
                                            <a href="/transition-professionnelle/bilan-retraite"><span>Bilan
                                                    retraite</span></a>
                                            <i v-if="tab === 'bilan-retraite'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'activ-projet') }">
                                            <a href="/transition-professionnelle/activ-projet"><span>Activ’
                                                    Projet</span></a>
                                            <i v-if="tab === 'activ-projet'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item"
                            v-if="tab !== 'organisme-formation' && tab !== 'soft-skills' && tab !== 'ressources-humaines-rse' && tab !== 'leadership-management'">
                            <h2 class="accordion-header">
                                <button class="accordion-button"
                                    :class="{ collapsed: (tab !== 'evaluation-candidat' && tab !== 'recrutement' && tab !== 'approche-directe' && tab !== 'assessment') }"
                                    type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                    aria-expanded="false" aria-controls="collapseThree">
                                    <i class="fa-light fa-users-medical me-2"></i> Recrutement
                                </button>
                            </h2>
                            <div id="collapseFive" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'evaluation-candidat' || tab === 'recrutement' || tab === 'approche-directe' || tab === 'assessment') }"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'evaluation-candidat') }">
                                            <a href="/recrutement/evaluation-candidat"><span>Evaluation
                                                    candidat</span></a>
                                            <i v-if="tab === 'evaluation-candidat'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'recrutement') }">
                                            <a href="/recrutement/recrutement"><span>Recrutement</span></a>
                                            <i v-if="tab === 'recrutement'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'approche-directe') }">
                                            <a href="/recrutement/approche-directe"><span>Approche directe</span></a>
                                            <i v-if="tab === 'approche-directe'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked': (tab === 'assessment') }">
                                            <a href="/recrutement/assessment"><span>Assessment</span></a>
                                            <i v-if="tab === 'assessment'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item"
                            v-if="tab === 'organisme-formation' || tab === 'soft-skills' || tab === 'ressources-humaines-rse' || tab === 'leadership-management'">
                            <h2 class="accordion-header">
                                <a href="/organisme-formation" class="accordion-button accordion-button-orange"
                                    :class="{ collapsed: (tab !== 'soft-skills' || tab !== 'ressources-humaines-rse' || tab !== 'leadership-management') }"
                                    type="button">
                                    <i class="fa-light fa-chalkboard-user me-2"></i>Organisme de formation
                                </a>
                            </h2>
                            <div id="collapseSix" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'organisme-formation' || tab === 'soft-skills' || tab === 'ressources-humaines-rse' || tab === 'leadership-management') }"
                                data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked-orange': (tab === 'soft-skills') }">
                                            <a href="/soft-skills"><span>Soft Skills</span></a>
                                            <i v-if="tab === 'soft-skills'" class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked-orange': (tab === 'ressources-humaines-rse') }">
                                            <a href="/ressources-humaines-rse"><span>Ressources Humaines et
                                                    RSE</span></a>
                                            <i v-if="tab === 'ressources-humaines-rse'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                        <li class="list-group-item  d-flex justify-content-between align-items-center"
                                            :class="{ 'itemChecked-orange': (tab === 'leadership-management') }">
                                            <a href="/leadership-management"><span>Leadership et Management</span></a>
                                            <i v-if="tab === 'leadership-management'"
                                                class="fa-solid fa-chevron-right"></i>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-item" v-if="tab === 'bilan-competences'">
                            <h2 class="accordion-header">
                                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                    data-bs-target="#collapseSeven" aria-expanded="false" aria-controls="collapseSeven">
                                    <i class="fa-light fa-chart-user me-2 me-2"></i>Bilan de compétences
                                </button>
                            </h2>
                            <div id="collapseSeven" class="accordion-collapse collapse"
                                :class="{ show: (tab === 'bilan-competences') }" data-bs-parent="#accordionExample">
                                <div class="accordion-body">
                                    <ul>
                                        <li><a href="#objectif_bilan">Les objectifs</a></li>
                                        <li><a href="#differentes_etapes">Les différentes étapes</a></li>
                                        <li><a href="#financement">Le financement</a></li>
                                        <li><a href="/bilan_competences/nos_centres">Les centres de Bilan</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a class="btn-bleu-outline"
                        v-if="tab === 'organisme-formation' || tab == 'soft-skills' || tab === 'ressources-humaines-rse' || tab === 'leadership-management'"
                        href="/#Nos-expertises"><i class="fa-regular fa-share-nodes me-2"></i>Nos Expertises</a>
                    <a class="btn-orange-outline" href="/organisme-formation"
                        v-if="(tab !== 'organisme-formation' && tab !== 'soft-skills' && tab !== 'ressources-humaines-rse' && tab !== 'leadership-management') || tab === 'bilan-competences'">
                        <i class="fa-light fa-chalkboard-user me-2"></i>
                        Organisme de formation
                    </a>
                    <a class="btn-rouge-outline" href="/bilan_competences" v-if="tab !== 'bilan-competences'">
                        <i class="fa-light fa-chart-user me-2 me-2"></i>
                        Bilan de compétences</a>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'transition-pro'">
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">
                        E.M.C.I. est une société de Conseil en Ressources Humaines, en Accompagnement Professionnel et
                        un
                        Centre
                        de Bilan de Compétences, créé en 1999.
                    </p>
                    <p class="pb-3 fw-bold">
                        Nos consultants (psychologues, juristes, ingénieurs, …), experts en évaluation des compétences
                        ont
                        une
                        très bonne connaissance du tissu économique régional. Ils accompagnent depuis plus de vingt ans
                        des
                        salariés, des cadres et des demandeurs d'emploi dans la construction concrète et réaliste de
                        leur
                        projet
                        professionnel et/ou de formation.
                    </p>
                    <p class="pb-3">
                        Nous sommes implantés sur de nombreuses villes en France, et nous réalisons aussi certaines
                        prestations
                        (bilan de compétences, formations...) à distance. Malgré ce fort développement territorial, nous
                        privilégions souplesse, écoute et réactivité. Nos exigences « Qualité », notre disponibilité,
                        notre
                        engagement auprès des entreprises et des Personnes (salariés, indépendants ou en recherche
                        d’emploi)
                        ainsi que notre proximité sont nos valeurs phares.
                        Nous avons une grande expérience de nombreux secteurs d’activité. Ceux des hautes technologies
                        (aéronautique, pharmaceutique, métallurgie, IA) le secteur des services (santé, aide à domicile,
                        bureautique…), le secteur culturel et bien d’autres...
                    </p>
                    <p class="pb-3">
                        EMCI vous accompagne dans votre projet professionnel, que vous soyez salarié, dirigeant,
                        demandeur
                        d'emploi, que vous vous questionniez sur vos capacités, vos compétences, que vous souhaitiez
                        évoluer
                        dans votre métier ou vous reconvertir, nos conseillers vous aideront à définir vos points forts,
                        vos
                        priorités et à mettre en place le plan d'actions pour réussir votre nouveau projet.
                    </p>
                    <p class="pb-3">
                        EMCI c'est aussi des formations professionnelles, formations au management, à la gestion des
                        ressources
                        humaines, au tutorat.
                    </p>
                    <p class="pb-3">
                        EMCI accompagne aussi les entreprises dans leur organisation, leur stratégie.
                        N'hésitez pas à nous contacter, nous sommes à votre écoute pour trouver l'accompagnement le
                        mieux
                        adapté
                        à votre problématique et à son financement.<br />
                        Nos locaux sont accessibles aux personnes en situation de handicap, conformément aux
                        dispositions de
                        l’annexe 8 de la circulaire interministérielle N° DGUHC 2007-53 du 30 Novembre 2007 .
                    </p>
                    <div class="d-flex justify-content-center">
                        <nuxt-img src="/images/pages/transition-pro/transition-pro.png"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3">
                        Lörem ipsum okrogt krofadade stenovis i tifisk autotåst. Spell sira habelt, tell. Renera
                        semifament
                        bigen sopspanare: rengen lavil.
                    </p>
                    <p class="pb-3">
                        Dibyrat dodobelt. Dypp etism, hana mimor förutom rejil oling, ining. Smartball kvasibel, trasade
                        ora,
                        podogt miren. Soska tefasade, och benymiskade. Relogi lolig, osysk i preliga. Bevis stenoskapet
                        och
                        polyling. Epirede lanas anatt. Sugon fade. Kak buck låbelig utom sådän.<br />
                        Pseudovis äburat om än tåhyvasor: samt mansskatt gigaheten. Fakiras multide kollektomat janing.
                        Kreativ
                        skolgång pseudons söktigt gigas telerat påhana. Monoliga egonelig plast anter i kabyktiga. Äsår
                        sona
                        i
                        eutinera. Georade regon bul eftersom trefynera än digt har ac-förkylning huruvida egospeskap.
                    </p>
                    <p class="pb-3">
                        Exotining spens till digt autonyledes pasat i supravis fade. Vir speledes. Lanat makrobunde
                        diarat
                        gigakask pred men koka böcker. <br />
                        Anasm donde håling autofining, ökrong. Kyprer sohavode, att tetranas. Nykäpådoren pongen såsade.
                        Jisår reism. Fas mir för eurogt, luvis. Sirepp kontrafase åvis emedan kisynade tinde knäprotest.
                        Ol poll dilig. Rer hossa 5:2-diet. Vagt eurobuv ost samt masat astroliga vinys.
                    </p>
                    <p class="pb-3">
                        Sytinisk sadässa spening. Dilig oll låling, som gigar och iss dir. Nyrade stenod mavise sede och
                        såbel,
                        och pret. Du kan vara drabbad. <br />
                        Nyr traktiga povavis fast tifir. Köttnorm telogi alltså tenat. Presk rest och test rede och
                        dänebel
                        och
                        belig rengen.
                        Mov yvira, syhet spende prerat sisamma. Ont södäfara såsk delingar kara väggord i vav.
                        Deciplasam
                        latrevis av anteplabåns, dos sadorade den bidat at.
                    </p>
                    <p class="pb-3">
                        Enade som bedat prepp, och åpretest. Immersiv senat bid. Autorade fav. Nend nik i pimpa den
                        ulingar
                        dobud. Kast sed vafajasm. Krobåling stenokasm befyr: monogt hossa kontrar. Dekar ded kroheten,
                        är
                        bukor
                        mire om teoosmos, hysir. Vitåd spevis tipp trakron sedor. Nyning milingar hånde än monologi i
                        bål.
                        Vateng ov rena i otåling mining pehåvis. Gigaktiga tralanade. Geosade koren.
                    </p>
                    <p class="pb-3">
                        Val nysk terade spev buvav: kroheten då nylogi. Tigt sok ifall peren, ons bekod bulingar samt
                        nilig.
                        Fyseliga reade, monosina eurotelasa medan parafist. Favis åst fikesk. Iprens sas, lorar fans
                        inte
                        tåtenat. Sanas tenas i selos.
                    </p>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'outplacement'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Appelée aussi reclassement externe, cette prestation permet au futur
                        licencié de
                        bénéficier d’un accompagnement individualisé et personnalisé afin de travailler un projet de
                        retour
                        à
                        l’emploi.</p>
                    <div class="pb-3">
                        <p>
                            Ses objectifs :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Faire le point sur ses compétences et atouts</li>
                            <li>Construire un projet professionnel (reconversion, formation, création d’entreprise…)
                            </li>
                            <li>Acquérir des techniques de recherche d’emploi afin d’optimiser son employabilité </li>
                            <li>Bénéficier d’un coaching dans la mise en œuvre du projet</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/transition-pro/outplacement.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <div class="pb-3">
                        <p>
                            Un accompagnement de 6 à 12 mois avec 4 phases principales :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Une étape bilan personnel et professionnel</li>
                            <li>L’élaboration d’un projet professionnel avec un plan d’actions concret pour sa
                                réalisation
                            </li>
                            <li>Une stratégie de recherche d’emploi travaillée en fonction du projet</li>
                            <li>Un coaching avec suivi des démarches dans l’opérationnalisation du projet </li>
                        </ul>
                    </div>
                    <p class="pb-3">
                        À savoir que l’outplacement peut être à l’initiative de l’employeur comme du salarié afin de
                        garantir
                        une solution de retour à l’emploi optimisée et durable.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'bilan-retraite'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Cet accompagnement s’adresse à tout actif terminant prochainement son
                        activité
                        et
                        souhaitant préparer ce changement en toute sérénité.</p>
                    <div class="pb-3">
                        <p>
                            Ses objectifs :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Apprécier les mesures à prendre pour réussir sa fin de carrière </li>
                            <li>Formaliser et transmettre son expérience </li>
                            <li>Bien aborder cette transition de vie </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/transition-pro/bilan-retraite.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p class="pb-3">
                        Vous participez à un atelier collectif (8 à 12 personnes) d’une durée d’une demi-journée à une
                        journée
                        selon vos besoins. Cet accompagnement peut aussi se décliner sous forme de sessions
                        individuelles
                        pour
                        un objectif plus personnalisé.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'activ-projet'">
                    <div class="pb-3">
                        <p>
                            Activ’projet est délivré dans le cadre du conseil en évolution professionnelle de France
                            Travail. Il vous permet d’élaborer ou de confirmer un ou plusieurs projets professionnels
                            avec l'appui d'un professionnel de l'orientation.
                        </p>
                    </div>
                    <div class="pb-3">
                        <p>
                            Activ’projet vous permettra :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>D’explorer des pistes professionnelles correspondant à vos critères et aux compétences
                                recherchées par les entreprises </li>
                            <li>De clarifier vos souhaits et aspirations</li>
                        </ul>
                    </div>
                    <p class="pb-3 fw-bold">POUR QUI ?</p>
                    <div class="pb-3">
                        <p>
                            Pour vous, si vous êtes demandeur d’emploi et que :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>vous souhaitez ou devez changer de métier,</li>
                            <li>vous n’avez pas encore d’idée de métiers ou vous avez une ou plusieurs pistes
                                professionnelles qui restent à confirmer, </li>
                            <li>vous êtes prêt à vous engager dans une démarche de réflexion sur vos souhaits et besoins
                                afin de définir un projet professionnel en lien avec le marché du travail et les
                                compétences recherchées par les entreprises. </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/activprojet/activprojet.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">ACTIV’PROJET EN DÉTAIL</p>
                    <p class="pb-3">
                        Sur une durée de 8 à 12 semaines maximum, Activ’projet vous aide à construire ou confirmer votre
                        projet professionnel. À partir d’un premier entretien d’analyse de votre situation
                        professionnelle et de vos souhaits d’évolution, votre conseiller conviendra avec vous du contenu
                        d’Activ’projet pour répondre au mieux à vos besoins.
                    </p>
                    <div class="pb-3">
                        <p>
                            Ainsi, vous pourrez :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>faire le point sur vos expériences et votre parcours professionnel, </li>
                            <li>identifier vos compétences, centres d’intérêt, valeurs et aspirations,</li>
                            <li>découvrir les emplois et métiers qui correspondent à vos critères et aux compétences
                                recherchées par les entreprises, </li>
                            <li>préciser ou confirmer les éléments de votre projet professionnel, </li>
                            <li>à l’issue, repartir avec une feuille de route permettant de rendre concret votre projet
                                professionnel</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe de conseillère insertion<i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'prevention-rps'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Stress et violence sont des risques professionnels pouvant porter atteinte à
                        l’intégrité physique et mentale des collaborateurs et ont une incidence néfaste sur la
                        performance
                        organisationnelle : absentéisme, turn-over, épuisement professionnel, image de marque dégradée…
                    </p>
                    <p class="pb-3">Les actions de prévention peuvent intervenir à trois moments distincts :</p>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>La prévention primaire, correspondant à l’ensemble des actions ayant pour but
                                d’identifier
                                et
                                éliminer les facteurs de risques à la source.</li>
                            <li>La prévention secondaire, visant à limiter les conséquences des RPS auprès des personnes
                                qui
                                en
                                ressentent les symptômes. Il s’agit d’une prévention dite corrective.</li>
                            <li>La prévention tertiaire, consistant à intervenir dans l’urgence auprès d’une personne ou
                                d’un
                                groupe de personnes pour les aider à reprendre leur travail.</li>
                        </ul>
                    </div>
                    <p class="pb-3">Prévenir les risques psychosociaux, c’est avant tout préserver la santé des salariés
                        et
                        contribuer au développement de la performance économique de l’entreprise.</p>
                    <hr>
                    <p class="pb-3 fw-bold">
                        En pratique ?
                    </p>
                    <p class="pb-3">
                        Nos interventions approchent et analysent les facteurs de risques sous l’angle organisationnel
                        et
                        psychosocial, en tenant compte des spécificités systémiques de l’entreprise, de sa direction et
                        de
                        son
                        management.
                    </p>
                    <p class="pb-3">
                        Plusieurs étapes peuvent être mobilisées selon vos besoins, en collaboration avec les acteurs
                        concernés
                        :
                    </p>
                    <div class="pb-3">
                        <ul class="stepsPrevention">
                            <li>1. Diagnostic prévention des risques psychosociaux</li>
                            <li>2. Accompagnement pour l’élaboration et la mise en oeuvre d’un plan d’action de
                                prévention
                            </li>
                            <li>3. Accompagnement du comité de pilotage dans la mise en place d’une démarche de
                                prévention
                            </li>
                            <li>4. Prévention individuelle : formations, accompagnement du parcours professionnel de vos
                                collaborateurs…</li>
                            <li>5. Prévention collective : formations, organisation du travail collectif, régulation de
                                la
                                charge de travail…</li>
                            <li>6. Prévention organisationnelle : rôle du management, politique RH, moyens et conditions
                                de
                                travail…</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/prevention-rps/img.jpeg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3">
                        Les séances sont animées par un professionnel compétent, psychologue du travail et de
                        l’accompagnement
                        professionnel, formé à cette démarche et n’ayant pas de lien hiérarchique avec ses membres.
                    </p>
                    <p class="pb-3">
                        L’intervenant mènera ces séances d’une durée et d’une fréquence adaptées selon votre besoin
                        spécifique.
                        Elles s’articuleront nécessairement avec les rythmes et activités de l’entreprise.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'organisme-formation'">
                    <p class="pb-3 fw-bold">
                        EMCI, organisme de formation reconnu se positionne comme un véritable expert dans les domaines
                        clés
                        du
                        développement personnel et professionnel.
                    </p>
                    <section class="background-orange">
                        <PoleDeFormation />
                    </section>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'soft-skills'">
                    <p class="pb-3 fw-bold">
                        Les Soft Skills ou compétences comportementales, sont devenues indispensables dans le monde
                        professionnel en évolution constante. Nous mettons en avant l'importance de ces compétences dans
                        la
                        réussite professionnelle et personnelle.
                    </p>
                    <p class="pb-3">
                        Que ce soit la communication efficace, la résolution de problèmes, l'empathie ou la créativité,
                        EMCI
                        propose des programmes de formation qui renforcent ces compétences essentielles, permettant aux
                        individus de réussir dans leur carrière et d’établir des relations fructueuses.
                    </p>
                    <h3 class="text-center">Nos modules de formation</h3>
                    <div class="pt-25 d-flex justify-content-center">
                        <i class="fa-solid fa-arrow-down"></i>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'ressources-humaines-rse'">
                    <p class="pb-3">
                        <b>Les Ressources Humaines et la RSE</b> (Responsabilité Sociétale des Entreprises) représentent
                        des
                        enjeux
                        cruciaux pour les organisations et les entreprises de toutes tailles et de tous secteurs.
                    </p>
                    <p class="pb-3">
                        Une formation dans ces domaines vous permettra de mieux comprendre ces enjeux et d'adopter des
                        pratiques plus responsables et durables. Vous pourrez mettre en place des pratiques RH et ou RSE
                        responsables adaptées aux défis contemporains actuels comme la transition écologique ou la
                        transition numérique
                    </p>
                    <h3 class="text-center">Nos modules de formation</h3>
                    <div class="pt-25 d-flex justify-content-center">
                        <i class="fa-solid fa-arrow-down"></i>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'leadership-management'">
                    <p class="pb-3">
                        Le <b>leadership et le management</b> sont des compétences essentielles pour diriger une équipe
                        ou
                        une organisation avec succès. Nos formations vous permettront d'acquérir des compétences clés
                        telles
                        que la prise de décision, la communication, la planification stratégique et la gestion du temps.
                    </p>
                    <p class="pb-3">
                        Vous allez renforcer l'efficacité de votre leadership en motivant vos équipes et en les
                        inspirant
                        avec succès. Le but est d’améliorer la productivité et de construire une culture d'entreprise
                        positive tout en étant capable de gérer le changement de manière proactive.
                    </p>
                    <h3 class="text-center">Nos modules de formation</h3>
                    <div class="pt-25 d-flex justify-content-center">
                        <i class="fa-solid fa-arrow-down"></i>
                    </div>
                </div>
                <div class="col-lg-7 p-5 overRead bilanCompetences" v-if="tab === 'bilan-competences'">
                    <div class="d-flex justify-content-between gap-4 pb-3 onMobile">
                        <div class="d-flex flex-column align-items-center gap-3">
                            <nuxt-img src="/images/pages/bilan-competences/bilan-competences-icon-1.png"></nuxt-img>
                            <span class="text-center">Vous voulez donner un nouvel élan à votre carrière ?</span>
                        </div>
                        <div class="d-flex flex-column align-items-center gap-3">
                            <nuxt-img src="/images/pages/bilan-competences/bilan-competences-icon-2.png"></nuxt-img>
                            <span class="text-center">Vous envisagez de changer de métier ou de secteur d'activité
                                ?</span>
                        </div>
                        <div class="d-flex flex-column align-items-center gap-3">
                            <nuxt-img src="/images/pages/bilan-competences/bilan-competences-icon-3.png"></nuxt-img>
                            <span class="text-center">Vous souhaitez reprendre une activité après une interruption de
                                parcours
                                ?</span>
                        </div>
                    </div>
                    <hr>
                    <div class="pt-3">
                        <p class="pt-3 pb-3">Vous vous retrouvez dans ces questions, et ne savez pas par où commencer.
                        </p>
                        <p class="pb-3">Le Bilan de compétences répondra à ces questions.</p>
                        <div>
                            <a class="btn-transparent" href="/contactez-nous">Prendre rendez-vous pour une présentation
                                gratuite et
                                sans
                                engagement <i class="fa-solid fa-arrow-right"></i> </a>
                          <a class="btn-transparent" href="/files/Catalogue BC 2026.pdf" target="_blank">Téléchargez nos programmes<i class="fa-solid fa-arrow-right"></i> </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'audit-social'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">L’objectif d’un audit social est l’évaluation de la situation sociale d’une
                        entreprise à un instant T. Il s’agit de faire le point sur les pratiques de l’entreprise dans la
                        gestion
                        de ses ressources humaines et également sur son organisation interne, en termes de méthodes de
                        travail,
                        optimisation des tâches… Le but ultime étant de garantir durablement la performance de
                        l’entreprise.
                    </p>
                    <div class="pb-3">
                        <p>
                            Cet audit peut être préventif : il consistera alors en un inventaire des différentes
                            pratiques
                            organisationnelles et managériales de la structure, en lien avec les évolutions
                            réglementaires
                            et
                            les exigences du marché, afin d’être les plus compétitifs possible.
                        </p>
                    </div>
                    <div class="pb-3">
                        <p>
                            Il peut également être curatif, dès lors qu’une problématique est identifiée. Il s’agira
                            alors
                            d’établir un diagnostic et de proposer des axes d’amélioration pour réajuster les pratiques
                            professionnelles.
                        </p>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/audit-social/LydieLecarpentier.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique ?</p>
                    <p class="pb-3">
                        À l’initiative de l’entreprise, le cabinet EMCI vous propose d’intervenir au sein de votre
                        structure
                        afin d’analyser vos besoins, mener une expertise et formaliser à vos côtés un plan d’action
                        efficace.
                        Le nombre d’interventions en entreprise, leur durée et leur fréquence sont à déterminer en
                        fonction
                        des
                        besoins et attentes de votre structure.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'gap'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Devenus obligatoires à compter du 1er septembre 2021 dans les lieux
                        d’accueil de
                        jeunes enfants, les groupes d’analyse de pratiques (GAP) s’adressent aux professionnels dans
                        lesquels
                        les relations humaines constituent une composante importante.</p>
                    <div class="pb-3">
                        <p>
                            Abordant les situations difficiles en lien avec le public accueilli, l’intérêt de ces
                            groupes
                            est
                            d’accompagner les professionnels à réfléchir sur leurs pratiques et dénouer leur implication
                            personnelle, relationnelle, affective… de leur posture professionnelle.
                        </p>
                    </div>
                    <div class="pb-3">
                        <p>
                            En ce sens, les objectifs de ces interventions permettent de :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Verbaliser les difficultés rencontrées par les professionnels</li>
                            <li>Prendre de la distance face à ces difficultés</li>
                            <li>Rechercher une amélioration de la pratique dans l’intérêt des personnes accompagnées
                            </li>
                            <li>S’enrichir des pratiques professionnelles des pairs et développer ses compétences grâce
                                à de
                                nouveaux outils</li>
                            <li>Encourager la performance collective, le dialogue social, les processus décisionnels
                            </li>
                            <li>Renforcer la cohésion d’équipe et harmoniser les pratiques.</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/gap/desc-picture02.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique ?</p>
                    <p class="pb-3">
                        Rassemblant une douzaine de professionnels, les séances sont animées par un professionnel
                        compétent,
                        psychologue du travail et de l’accompagnement professionnel, formé à cette démarche et n’ayant
                        pas
                        de
                        lien hiérarchique avec ses membres.
                    </p>
                    <p class="pb-3">
                        L’animateur mènera ces séances d’une durée et d’une fréquence adaptées selon votre besoin
                        spécifique.
                        Elles s’articuleront nécessairement avec les rythmes et activités de l’entreprise.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'mediation'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Intrinsèquement liée à la performance économique de l’entreprise, la qualité
                        de
                        vie
                        au travail dépend de la qualité des dynamiques communicationnelles construites autour du
                        travail.
                    </p>
                    <div class="pb-3">
                        <p>
                            Dans ce cadre, les espaces de médiation ou espaces de discussion tels que nommés par le
                            réseau
                            Anact-Aract, sont des espaces collectifs qui permettent une discussion centrée sur
                            l’expérience
                            de
                            travail, ses enjeux, les règles de métiers, les ressources et les contraintes…
                        </p>
                    </div>
                    <div class="pb-3">
                        <p>
                            En ce sens, ces groupes visent à :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Améliorer la qualité des relations interpersonnelles</li>
                            <li>Développer la reconnaissance, la professionnalisation, l’engagement des collaborateurs
                            </li>
                            <li>Restaurer le sens du travail</li>
                            <li>Réguler l’activité</li>
                            <li>Encourager la performance collective, le dialogue social, les processus décisionnels
                            </li>
                            <li>Faciliter la proposition d’amélioration collective, la production de solutions élaborées
                                conjointement par les participants.</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/mediation/img01.jpeg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique ?</p>
                    <p class="pb-3">
                        Rassemblant une douzaine de professionnels, les séances sont animées par un professionnel
                        compétent,
                        psychologue du travail et de l’accompagnement professionnel, formé à cette démarche et n’ayant
                        pas
                        de
                        lien hiérarchique avec ses membres.
                    </p>
                    <p class="pb-3">
                        L’animateur mènera ces séances d’une durée et d’une fréquence adaptées selon votre besoin
                        spécifique.
                        Elles s’articuleront nécessairement avec les rythmes et activités de l’entreprise.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'supervision'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Contrairement aux groupes d’analyse de pratiques centrés sur
                        l’accompagnement
                        des
                        usagers, les groupes de supervision s’intéressent aux professionnels eux-mêmes, à leur
                        fonctionnement, à
                        leur activité propre, à leurs relations</p>
                    <div class="pb-3">
                        <p>
                            La supervision les amènent à prendre de la distance vis-à-vis de leur quotidien
                            professionnel,
                            d’envisager une réflexion collective sur leurs valeurs, leurs priorités, leurs émotions,
                            leurs
                            modalités de communication, leurs représentations… quant à leurs postures et pratiques
                            professionnelles.
                        </p>
                    </div>
                    <div class="pb-3">
                        <p>
                            En ce sens, les objectifs de ces interventions permettent de :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Développer les compétences professionnelles et professionnaliser les relations de
                                travail
                            </li>
                            <li>Analyser les conditions de travail, l’organisation des activités professionnelles</li>
                            <li>Renforcer la capacité des participants à poser les justes limites dans leurs relations
                                avec
                                les
                                usagers</li>
                            <li>Faciliter la mise en cohérence des actions collectives</li>
                            <li>Contribuer à la synergie et à la cohésion des équipes, fédérer le collectif autour de
                                valeurs
                                partagées</li>
                            <li>Mobiliser les ressources individuelles, collectives et institutionnelles.</li>
                        </ul>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique ?</p>
                    <p class="pb-3">
                        Rassemblant une douzaine de professionnels, les séances sont animées par un professionnel
                        compétent,
                        psychologue du travail et de l’accompagnement professionnel, formé à cette démarche et n’ayant
                        pas
                        de
                        lien hiérarchique avec ses membres.
                    </p>
                    <p class="pb-3">
                        L’animateur mènera ces séances d’une durée et d’une fréquence adaptées selon votre besoin
                        spécifique.
                        Elles s’articuleront nécessairement avec les rythmes et activités de l’entreprise.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/supervision/desc-picture.jpg"></nuxt-img>
                    </div>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'pcrh'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">La Prestation Conseil en Ressources Humaines (PCRH) assure aux TPE-PME-PMI
                        un
                        accompagnement dispensé par des consultants RH externes à l’entreprise, experts en matière de
                        gestion
                        des ressources humaines et présents sur le territoire métropolitain. </p>
                    <div class="pb-3">
                        <p>
                            Cet accompagnement personnalisé et adapté vise à améliorer la gestion des ressources
                            humaines,
                            et
                            permet notamment :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>De structurer ou consolider les ressources humaines d’une entreprise : élaborer une
                                stratégie RH
                                à partir d’un diagnostic économique, professionnaliser la fonction RH dans l’entreprise,
                                développer la marque employeur, entrer dans une démarche RSE, apprendre à mieux
                                recruter,
                                intégrer de nouveaux salariés… </li>
                            <li>De renforcer les dynamiques professionnelles des salariés : élaborer un plan de
                                développement
                                des compétences, renforcer le dialogue social, améliorer l’organisation du travail,
                                favoriser la
                                qualité de vie au travail…</li>
                            <li>D’anticiper les changements RH pour faciliter et réussir la transformation numérique ou
                                écologique des organisations de travail.</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/conseil-rh/pcrh.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique… </p>
                    <p class="pb-3">
                        Le projet de l’entreprise sollicitant une Prestation Conseil en Ressources Humaines s’inscrit
                        nécessairement dans l’une ou plusieurs des dimensions suivantes :
                    </p>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Gestion prévisionnelle des emplois et des compétences GPEC, gestion des emplois et des
                                parcours
                                professionnels GEPP</li>
                            <li>Appui au recrutement et au développement de l’attractivité</li>
                            <li>Intégration des salariés dans l’entreprise</li>
                            <li>Accompagnement des entreprises aux mutations RH liées aux transitions, notamment
                                numériques
                                et
                                écologiques</li>
                            <li>Organisation du travail</li>
                            <li>Amélioration du dialogue social</li>
                            <li>Professionnalisation de la fonction RH dans l’entreprise</li>
                            <li>Accompagnement des situations de variations conjoncturelles d’activité.</li>
                        </ul>
                    </div>
                    <p class="pb-3">
                        Le contenu de la prestation est totalement personnalisable selon les besoins de l’entreprise.
                    </p>
                    <p class="pb-3">
                        Le coût peut éventuellement être pris en charge par l’Etat en cofinancement avec l’OPCO (selon
                        les
                        critères d’éligibilité en vigueur)
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'obligations_legales'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Dans le cadre de nos missions de conseil RH auprès des entreprises, nous
                        accompagnons les dirigeants et/ou les RRH dans la mise en place des obligations légales et
                        sociales
                        auxquelles ils sont soumis.</p>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique… </p>
                    <p class="pb-3">
                        Ces obligations légales et sociales varient en fonction des effectifs de l’entreprise.
                    </p>
                    <p class="pb-3">
                        <b>Pour les entreprises de 1 à 10 salariés</b>, nous accompagnons le dirigeant dans la rédaction
                        du
                        Document Unique d’Évaluation des Risques (DUERP), la mise en place d’une couverture santé
                        complémentaire
                        obligatoire, la réalisation de la déclaration d’emploi des travailleurs handicapés via la <a
                            href="https://www.kelio.com/fr/ressources/blog/1062-la-declaration-des-effectifs-en-dsn-modalites-et-enjeux.html"
                            target="_blank" class="a-underline">DSN</a> et
                        la mise
                        en place des affichages obligatoires.
                    </p>
                    <p class="pb-3">
                        <b>Pour les entreprises de 11 à 49 salariés</b>, l’un des principaux changements pour les
                        entreprises
                        franchissant le seuil des 11 salariés est l’obligation d’organiser des élections
                        professionnelles
                        afin
                        d’élire les membres du CSE qui seront alors en charge de porter à la connaissance de l’employeur
                        les
                        diverses demandes et réclamations individuelles et/ou collectives des collaborateurs ainsi que
                        de
                        contribuer à la promotion de la santé, de la sécurité et des conditions de travail au sein de
                        l’entreprise.
                    </p>
                    <p class="pb-3">
                        Si toutes les entreprises sont soumises à la DOETH, à savoir l’obligation de déclaration
                        d’emploi
                        des
                        travailleurs handicapés, seules les entreprises ayant un effectif d’au moins 20 personnes sont
                        soumises
                        à l’obligation d’un taux d’emploi des personnes handicapées à hauteur de 6% de leur effectif
                        global.
                        En
                        cas de non atteinte de ce taux de 6%, elles devront alors verser une contribution OETH,
                        déterminée
                        en
                        fonction des unités d’emploi manquantes.
                    </p>
                    <p class="pb-3">
                        <b>Pour les entreprises de 50 à 199 salariés</b>, nous accompagnons l’élargissement des missions
                        et
                        des
                        responsabilités du CSE avec la mise à disposition d’un local aménagé ainsi que du matériel
                        nécessaire à
                        l’exercice de leur fonction ; ainsi que la possibilité pour les syndicats de nommer un
                        représentant
                        de
                        section syndicale et un délégué syndical.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/conseil-rh/obligationslegales.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25" />
                    <p class="pb-3">
                        D’autres mesures devront également être mises en place au sein des entreprises dont l’effectif
                        est
                        au
                        moins égal à 50 salariés, il s’agit de :
                    </p>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>L’établissement d’un règlement intérieur.</li>
                            <li>L’aménagement de l’espace de restauration après consultation du CSE qui doit alors
                                comprendre un
                                moyen de conservation ou de réfrigération des aliments et boissons, la possibilité de
                                réchauffer
                                les plats, un robinet d’eau potable fraîche et chaude pour 10 personnes ainsi que des
                                chaises et
                                tables en nombre suffisant.</li>
                            <li>La tenue de négociation annuelle obligatoire (NAO) dans les entreprises comptant un
                                délégué
                                syndical.</li>
                            <li>La mise en place d’un accord de participation aux résultats de l’entreprise et son
                                affichage.
                            </li>
                            <li>Du versement obligatoire de la prime de partage des profits si la distribution des
                                dividendes
                                est supérieure à celle des deux exercices précédents.</li>
                            <li>L’affichage obligatoire des consignes en cas d’incendie.</li>
                            <li>La tenue et la mise à jour annuelle du document d’adhésion au service de santé
                                interentreprises.
                            </li>
                            <li>La mise en place d’un PSE en cas de projet de licenciement économique collectif de plus
                                de
                                10
                                salariés sur 30 jours.</li>
                            <li>La déclaration mensuelle auprès de la Dares des mouvements de personnel. </li>
                            <li>L’instauration d’une <a
                                    href="https://www.kelio.com/fr/ressources/blog/1072-bdes-quels-sont-les-criteres-d-une-bdes-complete-et-actualisee.html"
                                    target="_blank" class="a-underline">Base
                                    de Données Économiques, Sociales et Environnementales (BDESE)</a>.</li>
                        </ul>
                    </div>
                    <p class="pb-3">
                        À savoir : Lorsque les entreprises atteignent le seuil des 150 salariés, le CSE doit
                        obligatoirement
                        se
                        réunir une fois par mois.
                    </p>
                    <p class="pb-3">
                        <b>Pour les entreprises de 200 à 299 salariés</b>, nous accompagnons l’obligation de mettre à
                        disposition des sections syndicales un local commun permettant à leurs délégués d’exercer
                        convenablement
                        leurs missions.
                    </p>
                    <p class="pb-3">
                        Pour rappel, les entreprises franchissant le seuil des 250 salariés devront, elles, désigner un
                        référent
                        handicap ainsi qu’un référent de lutte contre les agissements sexistes. Elles devront également
                        communiquer le montant des rémunérations versées aux 10 personnes les mieux rémunérées de
                        l’entreprise.
                    </p>
                    <p class="pb-3">
                        <b>Pour les entreprises à compter de 300 salariés</b>, nous accompagnons les changements au sein
                        du
                        CSE
                        comme la transmission du rapport annuel du médecin du travail ainsi que la mise en place
                        obligatoire
                        de
                        diverses commissions, telles que :
                    </p>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>La commission santé, sécurité et conditions de travail.</li>
                            <li>La commission formation.</li>
                            <li>La commission d’information et d’aide au logement.</li>
                            <li>La commission de l’égalité professionnelle.</li>
                            <li>Sous conditions, la commission des marchés.</li>
                        </ul>
                    </div>
                    <p class="pb-3">
                        Les entreprises de plus de 300 salariés devront également établir annuellement leur bilan
                        social,
                        mener
                        des négociations obligatoires dans le cadre d’un accord de Gestion Prévisionnelles des Emplois
                        et
                        des
                        Compétences et prendre à leur charge les 5 jours de formation des membres du CSE.
                    </p>
                    <p class="pb-3">
                        Les syndicats auront également la possibilité de nommer un représentant syndical au sein du
                        CSE qui
                        sera
                        distinct du délégué syndical.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'entretien_annuel_professionnel'">
                    <p class="pb-5-annual fw-bold">L’entretien annuel </p>
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="fw-bold">L’entretien annuel a pour objectif de faire le point sur les compétences
                        développées
                        par
                        le salarié au sein de son poste ainsi que les objectifs professionnels fixés avec son
                        management.
                    </p>
                    <p class="pb-3">L'objectif de cette marque employeur est de rendre attractive une entreprise en
                        interne
                        pour
                        ses salariés et en externe pour les candidats. Cette démarche est bien évidemment propre à
                        chaque
                        entreprise selon son identité et ses objectifs.</p>
                    <p class="pb-3">
                        Contrairement à l’entretien professionnel il n’est pas obligatoire légalement mais absolument
                        nécessaire
                        pour piloter les ressources humaines, recueillir les besoins en formation et piloter les
                        carrières.
                    </p>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique… </p>
                    <p class="pb-3">
                        Il s’agit pour l’entreprise d’organiser un rendez-vous avec chaque salarié et la personne qui le
                        manage
                        afin de faire le point sur les compétences attendues au sein du poste, passer en revue les
                        points
                        forts
                        et les axes de progrès, identifier les formations internes, négocier une évolution de salaire.
                    </p>
                    <p class="pb-5-annual">
                        EMCI propose des formations à l’animation de ces entretiens et propose également des
                        accompagnements
                        sur
                        la réalisation des supports nécessaires pour tracer cet entretien.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/conseil-rh/entretien.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25" />
                    <p class="fw-bold">L’entretien professionnel </p>
                    <p class="pb-5-annual">L’entretien professionnel est obligatoire tous les 2 ans entre l’employeur et
                        le
                        salarié.
                    </p>
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3">Cet entretien est destiné à envisager des perspectives d’évolution professionnelle
                        et
                        les
                        formations qui peuvent contribuer à cette évolution.
                    </p>
                    <p>Différemment de l’entretien annuel il aborde l’intégralité du parcours professionnel et a pour
                        objectif de sécuriser le parcours du salarié : employabilité sur le marché de l’emploi, niveau
                        de diplôme en phase avec son poste etc.
                    </p>
                    <p class="pb-3">Il nécessite de la part de celui qui l’anime côté entreprise une vision globale des
                        possibilités
                        offertes au salarié.
                    </p>
                    <p class="pb-3 fw-bold">En pratique ?</p>
                    <p class="pb-3">Il peut être réalisé avec la personne dont vous dépendez hiérarchiquement ou avec la
                        personne qui dirige l’entreprise ou encore avec une personne chargée des ressources humaines.
                    </p>
                    <div class="d-flex justify-content-between mb-50 entretien">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/ressources-humaines-rse">Voir nos programmes de formation <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'marque_employeur'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="fw-bold">La marque employeur fait référence à la réputation d’une entreprise, elle vise à
                        promouvoir et à soigner l'image de l'entreprise.</p>
                    <p class="pb-3">L'objectif de cette marque employeur est de rendre attractive une entreprise en
                        interne
                        pour
                        ses salariés et en externe pour les candidats. Cette démarche est bien évidemment propre à
                        chaque
                        entreprise selon son identité et ses objectifs.</p>
                    <p class="pb-3">
                        La marque employeur repose sur divers facteurs, notamment la culture d'entreprise, les avantages
                        sociaux, les opportunités de carrière, le leadership, les valeurs de l'entreprise, la
                        responsabilité
                        sociale, la rémunération et la reconnaissance.
                    </p>
                    <p class="pb-3">
                        Elle joue un rôle essentiel non seulement pour promouvoir une entreprise comme un employeur de
                        choix
                        sur
                        le marché du travail, et ainsi attirer des candidats qualifiés, mais aussi pour renforcer
                        l'engagement
                        des employés et améliorer la rétention du personnel.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/conseil-rh/marqueemployeur.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">Et, en pratique… </p>
                    <p class="pb-3">
                        Travailler sur la marque employeur est un investissement à long terme qui nécessite de
                        l'engagement
                        et
                        de la cohérence pour réussir à attirer et à conserver les meilleurs talents pour votre
                        entreprise.
                    </p>
                    <p class="pb-3">
                        De la définition de votre identité d’entreprise à l’élaboration d’un plan stratégique, nous vous
                        accompagnons tout au long de ce process pour développer et renforcer <b>l'image de votre
                            entreprise
                            en
                            tant qu'employeur de choix</b>.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'gepp'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Anciennement gestion prévisionnelle des emplois et des compétences (GPEC),
                        la
                        gestion des emplois et des parcours professionnels (GEPP) constitue une démarche proactive de
                        gestion
                        des compétences des salariés.</p>
                    <div class="pb-3">
                        <p class="pb-3">
                            Grâce à la cartographie des ressources disponibles, cet outil a pour but de s’adapter au
                            monde
                            du
                            travail, de répondre à ses attentes et de faire face aux mutations organisationnelles,
                            technologiques, économiques, sociales, juridiques auxquelles nous sommes confrontés.
                        </p>
                        <p class="pb-3">
                            La GEPP s’envisage comme une démarche participative de l’ensemble des salarié.e.s,
                            nécessitant
                            un
                            engagement de toute la ligne hiérarchique ; elle aide à renforcer la fidélité des
                            collaborateurs
                            tout en agissant sur la compétitivité et la productivité des entreprises.
                        </p>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/conseil-rh/gepp.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique… </p>
                    <p class="pb-3">
                        La GEPP assure une approche globale de la vie professionnelle du salarié. Ainsi, chaque
                        collaborateur
                        peut bénéficier d’une formation continue régulière, d’un suivi et d’une progression de carrière,
                        d’évolutions professionnelles internes adaptées à ses capacités et compétences.
                    </p>
                    <p>
                        Pour toute entreprise de plus de 300 salarié.e.s, la gestion des emplois et des parcours
                        professionnels
                        est obligatoire. Tous les 3 ans, l’employeur et les partenaires sociaux engagent une négociation
                        sur
                        la
                        GEPP et sur la mixité des métiers.
                    </p>
                    <p class="pb-3">
                        Au sein de plus petites entreprises, cet outil peut également être parfaitement adapté, mobilisé
                        et
                        déployé.
                    </p>
                    <p class="pb-3">
                        Nous vous accompagnons pour la mise en œuvre de la GEPP au sein de votre structure.
                    </p>
                    <div class="pb-3">
                        <p>
                            Cet accompagnement est dispensé par un professionnel consultant RH compétent, expert en
                            gestion
                            des
                            ressources humaines et organisation du travail.
                        </p>
                        <p>
                            Il mènera ces interventions d’une durée et d’une fréquence adaptées à votre besoin
                            spécifique.
                        </p>
                    </div>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'coaching_professionnel'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="fw-bold">Il s’agit d’un accompagnement visant l’évolution d’une personne ou d’une équipe
                        afin
                        de maximiser son potentiel personnel et professionnel.</p>
                    <p class="pb-3">
                        Encadré par un psychologue du travail ou un coach certifié, le coaching professionnel s’adresse
                        à
                        des
                        personnes qui ont besoin d’être guidées dans la mise en place et la réalisation de leurs
                        objectifs.
                    </p>
                    <div class="pb-3">
                        <p>
                            Ses objectifs :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Mieux se connaître pour mieux évoluer</li>
                            <li>Développer des aptitudes au changement</li>
                            <li>Gérer de manière optimale ses émotions </li>
                            <li>Faciliter la prise de décision </li>
                            <li>Améliorer sa communication </li>
                            <li>Favoriser une mise en mouvement </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/management/management01.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p class="pb-3">
                        Il peut être individuel : lorsqu’il s’agit d’accompagner une personne dans l’accomplissement de
                        son
                        plein potentiel, lors d’une prise de poste, d’une promotion… Différents thèmes peuvent être
                        abordés
                        selon les besoins du coaché : développement personnel, communication, leadership…
                    </p>
                    <p class="pb-3">
                        Il peut également être collectif lorsqu’il concerne l’accompagnement d’une équipe lors d’un
                        changement
                        d’organisation, de restructuration, de problématiques managériales par exemple.
                    </p>
                    <p>
                        Le nombre de séances et leur fréquence sont fixés en fonction des besoins du coaché et de son
                        entreprise.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'conduite_du_changement'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Élément déterminant pour être toujours innovant, percutant et en perpétuelle
                        progression, la conduite du changement est au cœur de nos métiers aujourd’hui. </p>
                    <div class="pb-3">
                        <p>
                            Le cabinet EMCI vous propose d’accompagner ces moments de transition au sein de votre
                            entreprise.
                        </p>
                    </div>
                    <div class="pb-3">
                        <p>
                            Les objectifs :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Identifier les enjeux de la conduite du changement</li>
                            <li>Comprendre les causes de résistance et faire accepter le changement aux collaborateurs
                            </li>
                            <li>Développer les nouvelles compétences nécessaires pour mobiliser l’intégralité des
                                personnes
                            </li>
                            <li>Traduire les objectifs en plan d’actions</li>
                            <li>Engager la communication autour du changement</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/management/management02.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p class="pb-3">
                        Cet accompagnement peut être mené sous forme de séances individuelles lorsque ce changement
                        engage une seule personne ou sous forme de séances collectives lorsqu’il s’agit de mobiliser
                        plusieurs collaborateurs dans cet objectif de changement.
                    </p>
                    <p>
                        La durée, le nombre et la fréquence sont à déterminer au démarrage de la prestation en fonction
                        des
                        besoins de l’entreprise et des personnes concernées.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'accompagnement_codir'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">L'accompagnement du comité de direction, souvent appelé "CODIR", est le
                        processus
                        dans lequel un consultant ou coach, va travailler en étroite collaboration avec les membres du
                        comité de
                        direction d'une entreprise.</p>
                    <div class="pb-3">
                        <p>
                            L'objectif de cet accompagnement CODIR est généralement d'améliorer la performance
                            collective du
                            comité de direction, de renforcer la cohésion d'équipe, et de favoriser une meilleure prise
                            de
                            décision.
                        </p>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/management/management03.png"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p class="pb-3">
                        Le consultant en immersion dans le CODIR, va analyser et travailler certains points avec les
                        différents
                        membres, comme : l’alignement stratégique, la communication et la collaboration, la dynamique de
                        l’équipe, le développement des compétences, la facilitation des réunions, la résolution des
                        conflits, …
                    </p>
                    <p class="pb-3">
                        C'est un processus sur mesure, que le consultant veillera à adapter aux besoins spécifiques de
                        votre
                        organisation.
                    </p>
                    <p>
                        Cet accompagnement CODIR est d’autant plus bénéfique, dans un environnement commercial en
                        constante
                        évolution, et où l’adaptabilité, la prise de décision rapide et efficace sont cruciales
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'team_building'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Le Team building, « construction d’équipe » en Anglosaxon, est une pratique
                        permettant de renforcer les liens entre les membres d’une équipe. Elle consiste à réunir
                        l’ensemble
                        des
                        collaborateurs d’une entreprise autour d’une activité ludique, sportive ou culturelle et
                        permettre
                        ainsi
                        une participation collective.</p>
                    <div class="pb-3">
                        <p>
                            Ses objectifs :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Améliorer le climat social de l’entreprise</li>
                            <li>Stimuler la motivation individuelle et l’intelligence collective</li>
                            <li>Renforcer les liens entre les employés (cohésion d’équipe)</li>
                            <li>Faciliter la communication</li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/management/management04.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p>
                        Durant une après-midi, une journée ou un week-end, EMCI vous propose d’organiser pour votre
                        entreprise
                        ce moment convivial et de partage, à travers une activité sur-mesure en fonction de vos envies
                        et de
                        vos
                        besoins.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'co_developpement'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Approche de développement de compétences innovante développée au Québec, le
                        co-développement ou coaching en étoile réunit un groupe de pairs partageant les mêmes
                        problématiques
                        professionnelles sur un temps déterminé.</p>
                    <p class="pb-3">
                        La méthodologie structurée du co-développement mobilise l’intelligence collective pour clarifier
                        des
                        situations professionnelles, faire émerger des hypothèses de réponses à des problèmes communs et
                        des
                        situations réelles et vécues, dans un cadre d’écoute, de confidentialité, de parité.
                    </p>
                    <div class="pb-3">
                        <p>
                            Le co-développement a pour fonction :
                        </p>
                    </div>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>D’améliorer les pratiques professionnelles et les compétences d’une équipe </li>
                            <li>D’optimiser l’efficacité de l’organisation de travail </li>
                            <li>De soutenir la gestion d’un changement ou d’accompagner une réorganisation </li>
                            <li>De mieux anticiper et gérer les risques psychosociaux. </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img" src="/images/pages/management/management05.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p class="pb-3">
                        Organisé sous forme d’ateliers, le groupe constitué d’une dizaine de pairs choisit une
                        problématique
                        à
                        explorer : tous les participants du co-développement s’engagent à aider et soutenir la personne
                        qui
                        expose sa situation.
                    </p>
                    <p class="pb-3">
                        L’animateur est garant du cadre et du bon déroulement du co-développement : il guide les
                        échanges,
                        accompagne l’avancée du groupe au travers des différentes étapes définies dans le
                        co-développement
                        et
                        gère le temps.
                    </p>
                    <p>
                        Les ateliers sont animés par un professionnel compétent, psychologue du travail et de
                        l’accompagnement
                        professionnel, coach professionnel, formé à cette démarche et n’ayant pas de lien hiérarchique
                        avec
                        les
                        membres du groupe.
                    </p>
                    <div class="d-flex justify-content-between mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                        <a class="btn-transparent" href="/equipe">Découvrir notre équipe <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'evaluation-candidat'">
                    <p class="pb-3">Il s’agit de réaliser une évaluation de potentiel, de personnalité et de motivations
                        par
                        rapport à un poste ciblé : </p>
                    <div class="pb-3">
                        <ul class="listPreventionRps">
                            <li>Soit dans le cadre de la mobilité interne pour un poste donné.</li>
                            <li>Soit dans le cadre d’une sélection externe pour des candidats identifiés en amont par
                                l’entreprise</li>
                        </ul>
                    </div>
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">Le candidat passe des questionnaires de personnalité, d’aptitudes et de
                        motivation,
                        puis il est reçu en entretien individuel par un consultant.</p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/recrutement/recrutement01.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique… </p>
                    <p class="pb-3">
                        Une fois les sessions de tests passées et les entretiens réalisés, une synthèse détaillée est
                        remise
                        à
                        l’entreprise ce qui lui permettra de sélectionner le profil le plus en adéquation avec le poste
                        recherché.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'recrutement'">
                    <p class="pb-3">Dénicher de nouveaux talents et profils adaptés aux besoins de votre entreprise, ne
                        s’improvise pas.</p>
                    <p class="pb-3 fw-bold">Le recrutement est une étape cruciale dans la gestion des ressources
                        humaines
                        d'une
                        organisation : le recrutement de candidats appropriés peut avoir un impact significatif sur la
                        performance et la réussite de l'entreprise. </p>
                    <p class="pb-3 fw-bold">De la compréhension de vos besoins, définition de votre marque employeur à
                        l’intégration réussie du nouveau collaborateur, nous vous accompagnons tout au long de ce
                        process.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/recrutement/recrutement02.jpg"></nuxt-img>
                    </div>
                    <div class="pb-3">
                        <p>Notre méthodologie en 10 étapes : </p>
                    </div>
                    <div class="pb-3">
                        <RecrutementStep />
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3">
                        L'objectif principal du recrutement est de trouver les meilleurs talents pour votre entreprise
                        afin
                        de
                        garantir sa croissance et son succès futur.
                    </p>
                    <p class="pb-3">
                        Le processus de recrutement peut varier en fonction de l'organisation et du poste à pourvoir.
                    </p>
                    <p class="pb-3">
                        Notre équipe d’experts saura répondre à vos attentes.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/equipe">Découvrez notre équipe recrutement
                            <i class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'approche-directe'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="fw-bold">Le recrutement par approche directe, communément appelé chasse de tête, repose
                        sur
                        une méthodologie distincte du recrutement par annonce ou par sourcing. </p>
                    <p>Intégré dans une approche de conseil sur mesure auprès des décideurs, le recrutement par approche
                        directe
                        se caractérise par sa discrétion et sa confidentialité. </p>
                    <p class="pb-3">
                        Cette méthode est adoptée uniquement lorsque le cabinet de recrutement décide de suivre cette
                        approche
                        en accord avec son client.
                    </p>
                    <p class="pb-3">
                        Opter pour un cabinet de chasseur de tête pour ses besoins de recrutement signifie chercher les
                        compétences là où elles se trouvent.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/recrutement/recrutement03.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">Le pratique...</p>
                    <p class="pb-3">
                        En utilisant des méthodes et des outils spécifiques à l'expertise du cabinet (tels que les
                        annuaires,
                        l'analyse des organigrammes, la liste des entreprises cibles, la création de scénarios, etc.),
                        le
                        chasseur de tête identifie et prend contact avec des individus susceptibles de correspondre au
                        profil
                        recherché.
                    </p>
                    <p class="pb-3">
                        Il s'assure également que les aspirations professionnelles de la personne approchée concordent
                        avec
                        les
                        besoins exprimés par l'entreprise.
                    </p>
                    <p class="pb-3">
                        Le recrutement par approche directe exige une expertise approfondie en matière de connaissance
                        des
                        divers métiers et secteurs d'activité, tout en respectant scrupuleusement les normes éthiques et
                        déontologiques propres aux métiers du recrutement.
                    </p>
                    <p class="pb-3">
                        Notre équipe d'experts EMCI saura vous accompagner dans cette démarche et ainsi répondre à vos
                        attentes.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/equipe">Découvrez notre équipe recrutement<i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
                <div class="col-lg-8 ps-5" v-if="tab === 'assessment'">
                    <p class="pb-3 fw-bold">De quoi s’agit-il ?</p>
                    <p class="pb-3 fw-bold">L’assessment center ou centre d’évaluation est une méthode d’évaluation des
                        compétences d’un candidat utilisée par les entreprises ou les experts en ressources humaines.
                    </p>
                    <p class="pb-3">
                        Il a pour but d’observer le comportement dans un milieu professionnel, d’évaluer les aptitudes
                        et
                        les
                        compétences, d’identifier la capacité à interagir en collectif, de gérer le stress et les
                        imprévus,
                        d’être en capacité de prendre des décisions, d’écouter et de collaborer…
                    </p>
                    <p class="pb-3">
                        L’assessment est une étape clé de l’évaluation lors d’une prise de poste : il constitue un outil
                        d’aide
                        à la décision pour un recrutement externe, une évolution de carrière, une mobilité interne, une
                        réorganisation… Il permet d’établir des éléments factuels et concrets pour appuyer les
                        réflexions et
                        partager les décisions avec des arguments objectivés, ce qui limite les interférences et les
                        biais
                        dans
                        l’évaluation.
                    </p>
                    <div class="d-flex justify-content-center pb-25 pt-25">
                        <nuxt-img class="prevention-rps-img"
                            src="/images/pages/recrutement/recrutement04.jpg"></nuxt-img>
                    </div>
                    <hr class="pb-25">
                    <p class="pb-3 fw-bold">En pratique...</p>
                    <p class="pb-3">
                        L’assessment s’effectue sur une session d’un ou deux jours, pendant laquelle le candidat est
                        amené à
                        passer des tests ; l’objectif visé est de l’immerger en situation réelle pour l’amener à traiter
                        et
                        résoudre des problématiques potentielles rencontrées en poste.
                    </p>
                    <p class="pb-3">
                        Les tests peuvent être individuels (personnalité, intérêts, valeurs ou aptitudes
                        professionnelles…),
                        en
                        binôme et/ou en collectif (mises en situation, études de cas, jeux de rôles…).
                        Ils sont adaptés au profil de poste visé, et co-définis avec l’entreprise concernée. Dans ce
                        cadre,
                        un
                        référentiel de compétences techniques et comportementales associé à des exercices de mise en
                        pratique
                        est construit conjointement.
                    </p>
                    <p class="pb-3">
                        Pour gagner en fiabilité et en objectivité, notre méthodologie repose sur l’observation
                        multiple des compétences : en effet, celles-ci doivent être observées à minima dans deux
                        exercices
                        ou
                        tests différents, et par deux observateurs qualifiés.
                    </p>
                    <p class="pb-3">
                        Par ailleurs, un document de synthèse est remis aux candidats, leur donnant accès à l’ensemble
                        de
                        leurs
                        résultats. Cette restitution, garante de notre éthique professionnelle, pourra être enrichie par
                        un
                        échange oral complémentaire à l’attention du candidat ou du décideur.
                    </p>
                    <p class="pb-3">
                        La prestation est animée par un professionnel consultant RH, expert en gestion des ressources
                        humaines
                        et organisation du travail. Il mènera ces séances en concertation et selon votre besoin
                        spécifique.
                    </p>
                    <div class="d-flex justify-content-left mb-50">
                        <a class="btn-transparent" href="/contactez-nous">Vous souhaitez échanger ? <i
                                class="fa-solid fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import RecrutementStep from '@/components/emci/Recrutement/Recrutement/RecrutementStep/index.vue';
import PoleDeFormation from '@/components/emci/PoleDeFormation/index.vue'

defineProps({
    tab: String,
    breadcrumb1: String,
    breadcrumb2: String
})

onMounted(() => {
    const scrollToAnchor = (e) => {
        e.preventDefault(); // Empêche le comportement par défaut du lien ancre

        const targetId = e.target.getAttribute('href'); // Récupère l'ID de la cible
        const targetElement = document.querySelector(targetId); // Sélectionne l'élément cible

        if (targetElement) {
            const navbarHeight = 0// Récupère la hauteur de la navbar wtf pourquoi je dois la mettre à 0 ????
            const targetPosition = targetElement.offsetTop - navbarHeight; // Calcule la position de la cible en tenant compte de la hauteur de la navbar

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth' // Pour un défilement fluide
            });
        }
    };

    // Sélectionnez tous les liens ancre
    const links = document.querySelectorAll('a[href^="#"]');


    links.forEach(link => {
        link.addEventListener('click', scrollToAnchor);
    });
});
</script>

<style scoped>
.background-orange {
    background: #FFD186;
}

.a-underline {
    text-decoration: underline;
    color: var(--bs-link-color);
}

.pb-5-annual {
    margin-bottom: 4rem !important;
}

.accordion-button {
    background: #318EC7;
    color: white;

    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.accordion-button::after {
    background-image: none;
}

.accordion-button:hover {
    background: var(--deg-1, linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%)) !important;
}

.accordion-button:not(.collapsed) {
    background: var(--deg-1, linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%));
    color: white;
}

.accordion-button-orange:not(.collapsed) {
    background: var(--secondaire, #FAB74B);
    color: white;
}



.accordion-body ul li {
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 145%;
    /* 23.2px */
    letter-spacing: 0.64px;
    margin: 1rem
}

.accordion-body ul li:hover {
    text-decoration: underline;
    cursor: pointer;
}

p {
    font-size: 18px !important;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.breadcrumb {
    font-size: 16px;
    font-weight: 400;
    line-height: 145%;
    letter-spacing: 0.64px;
    font-family: Inter;
}

.breadcrumb i {
    font-size: 14px;
}

.listPreventionRps,
.stepsPrevention {
    list-style-type: disc;
    padding: revert;
}

.btn-transparent:hover {
    color: #fff;
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.prevention-rps-img {
    height: 380px;
    width: 100%;
    object-fit: cover;
    border-radius: 9px;
}

.overRead {
    max-height: 700px;
    overflow: auto;
}

.btn-orange-outline {
    font-family: "Inter";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 500;
    width: 100%;
    border-radius: 9px;
    background-color: var(--orange);
    padding: 10px 20px;
    border: none;
}

.btn-orange-outline:hover,
.btn-rouge-outline:hover,
.btn-bleu-outline:hover {
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
    border: none;
}

.btn-bleu-outline:hover {
    color: white;
}

.btn-rouge-outline {
    font-family: "Inter";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 500;
    width: 100%;
    border-radius: 9px;
    background-color: var(--rouge);
    padding: 10px 20px;
    color: white;
    border: none;
}

.btn-bleu-outline {
    font-family: "Inter";
    font-size: 1.25rem;
    font-style: normal;
    font-weight: 500;
    width: 100%;
    border-radius: 9px;
    background-color: #318EC7;
    padding: 10px 20px;
    color: white;
    border: none;
    margin-top: 1rem;
}

.fa-arrow-down {
    font-size: 32px;
}

.bilanCompetences {
    border-radius: 30px;
    border: 3px solid #F4989D;
    margin-left: 3rem;
}

.bilanCompetences span {
    color: #E94B54;
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
    /* 28.98px */
    letter-spacing: 0.84px;
}

.bilanCompetences .btn-transparent {
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    transition: all .1s;
    width: 100%;
    justify-content: center;
}

.bilanCompetences .btn-transparent:hover {
    color: #fff;
    background: linear-gradient(93deg, #318EC7 9.92%, #E94B54 52.75%, #FAB74B 88.05%);
}

.bilanCompetences p {
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 138%;
    /* 28.98px */
    letter-spacing: 0.84px;
    text-align: center;
}

.itemChecked {
    background: var(--tertiaire-300, #D2EEFF);
    text-transform: capitalize;
    margin: -20px !important;
    padding-left: 35px;
    padding: 5px;
    padding-left: 35px;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.itemChecked-orange {
    background: var(--secondaire-300, #FFEFD4);
    text-transform: capitalize;
    margin: -20px !important;
    padding-left: 35px;
    padding: 5px;
    padding-left: 35px;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
}

.itemChecked span,
.itemChecked-orange span {
    text-decoration: underline;
}

.itemChecked i {
    margin-right: 15px;
    font-weight: 700;
}

p {
    font-family: Inter;
}

.entretien .btn-transparent {
    padding: 7px 25px;
}

/*
* Media responsive
*/

@media only screen and (min-width: 100px) and (max-width: 250px) {
    .bilanCompetences {
        min-height: 174vh !important;

    }
}

@media only screen and (min-width: 100px) and (max-width: 768px) {
    .breadcrumb {
        font-size: 14px;
    }

    .accordion-button {
        font-size: 15px;
    }

    p {
        font-size: 15px !important;
    }

    .btn-transparent {
        font-size: 12px !important;
        padding: 2% 3%;
    }

    .bilanCompetences {
        margin-top: 2rem;
        margin-left: 0px;
        min-height: 110vh;
    }

    .bilanCompetences span {
        max-width: 50%;
        font-size: 13px;
    }

    .p-5 {
        padding: 0.1rem !important;
        padding-top: 3rem !important;
    }

    .mb-50 {
        margin-bottom: 0px;
        justify-content: center;
    }

    .onMobile {
        flex-direction: column;
    }

    .d-flex.justify-content-between.mb-50, .entretien {
        flex-direction: column;
    }

    .entretien .btn-transparent {
        padding: 7px 15px;
    }


}


@media only screen and (min-width: 100px) and (max-width: 768px) {
    .col-lg-4.col-md-5.tablette {
        display: none;
    }

    .container.pt-70 {
        padding-top: 0px;
    }

    .ps-5 {
        padding-left: 0.5rem !important;
    }
}


/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {
    .col-lg-4.col-md-5.tablette {
        margin: 0 210px !important;
    }
}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .container.pt-70.pb-70 {
        max-width: 95% !important;
    }
}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}

/* end custom */
</style>